import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import { separateThousands } from '@alfa-bank/site-helpers-transform/numbers/separate-thousands';

import { configs } from '../configs';
import styles from '../styles/styles-desktop.css';
import { ButtonDecreaseDesktop } from '../components/buttons/desktop-button-decrease';
import { ButtonIncreaseDesktop } from '../components/buttons/desktop-button-increase';
import type { TIncrementDecrementDeskstop, IDepsDesktop } from '../models';

import { IncrementDecrement as Component } from './increment-decrement';

// Компоненту не требуется функционал стайлера
// eslint-disable-next-line styler/check-styler
export const IncrementDecrementDesktop = createWidget<IDepsDesktop, TIncrementDecrementDeskstop>({
    configs,
    styles,
    Text,
    separateThousands,
    ButtonDecrease: ButtonDecreaseDesktop,
    ButtonIncrease: ButtonIncreaseDesktop,
})(Component);
